/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FreightCalculatorRespVo } from './FreightCalculatorRespVo';
import {
    FreightCalculatorRespVoFromJSON,
    FreightCalculatorRespVoFromJSONTyped,
    FreightCalculatorRespVoToJSON,
    FreightCalculatorRespVoToJSONTyped,
} from './FreightCalculatorRespVo';

/**
 * 
 * @export
 * @interface ResponseFreightCalculatorRespVo
 */
export interface ResponseFreightCalculatorRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseFreightCalculatorRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseFreightCalculatorRespVo
     */
    message?: string;
    /**
     * 
     * @type {FreightCalculatorRespVo}
     * @memberof ResponseFreightCalculatorRespVo
     */
    data?: FreightCalculatorRespVo;
}

/**
 * Check if a given object implements the ResponseFreightCalculatorRespVo interface.
 */
export function instanceOfResponseFreightCalculatorRespVo(value: object): value is ResponseFreightCalculatorRespVo {
    return true;
}

export function ResponseFreightCalculatorRespVoFromJSON(json: any): ResponseFreightCalculatorRespVo {
    return ResponseFreightCalculatorRespVoFromJSONTyped(json, false);
}

export function ResponseFreightCalculatorRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseFreightCalculatorRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : FreightCalculatorRespVoFromJSON(json['data']),
    };
}

export function ResponseFreightCalculatorRespVoToJSON(json: any): ResponseFreightCalculatorRespVo {
    return ResponseFreightCalculatorRespVoToJSONTyped(json, false);
}

export function ResponseFreightCalculatorRespVoToJSONTyped(value?: ResponseFreightCalculatorRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': FreightCalculatorRespVoToJSON(value['data']),
    };
}

